import './customer_labels_filter_view.js.coffee';# Added by Script 
class Monitoring.Views.SocialContents.Filters.ResponseTemplateCustomerGroupsFilterView extends Monitoring.Views.SocialContents.Filters.CustomerLabelsFilterView

  initialize: (@options = {}) ->
    super(@options)
    @useCustomValues = @options.useCustomValues

  _addCustomValues: (terms) ->
    if @useCustomValues
      super(terms)
